<script setup>
import { BTable, BModal, BFormInput,BButton } from 'bootstrap-vue-next'
import HeaderContent from '@/components/HeaderContent.vue';
import DataTable from '@/components/DataTable.vue';
import FilterSearch from '@/components/FilterSearch.vue';
import dateFormatter from '@/composable/dateFormatter';
// import ButtonCta from '@/components/ButtonCta.vue';
import {reactive, ref, inject, onMounted} from 'vue'


const repositories = inject('repositories');

const inventoryDefectRepository = repositories ? repositories.inventoryDefect : null;
const inventoryData = ref([])

const detailModal = reactive({
    showModal : false,
    detailTotal : 0,
    detailName : '',
    dataDetail : []

})

// function to show detail
const showDetail = (data) => {
    detailModal.showModal = !detailModal.showModal
    detailModal.dataDetail = data.detail
    detailModal.detailName = data.name
    detailModal.detailTotal = data.total
}

const fields =[
    { key: 'inventory.item_name', label: 'Name',class: 'text-left'},
    { key: 'inventory.type', label: 'Category',class: 'text-center'},
    { key: 'total', label: 'Total',class: 'text-center'},
    { key: 'last_update', label: 'Last Update',thClass:'text-center',tdClass:'text-center'},
    { key: 'updated_by', label: 'Updated By',class: 'text-center'},
    { key: 'action', label: 'Action',thClass:'text-center',tdClass:'text-center'},  
    
    
]

const customActions = [
    {
        label: 'History',
        variant: 'secondary',
        icon: 'fas fa-history',
        action: (item) => {
            showDetail(item);
        // Implement your Info logic here
        }
    },
    {
        label: 'Edit',
        variant: 'success',
        icon: 'fas fa-edit',
        action: (item) => {
        showDetail(item);
        // Implement your Payment logic here
        }
    },
    {
        label: 'Delete',
        variant: 'danger',
        icon: 'fas fa-trash',
        action: (item) => {
        console.log('Check In action clicked for:', item);
        // Implement your Checkout logic here
        }
    },
]

const getAll = async () => {
    await inventoryDefectRepository.getAll().then((res) => {
    inventoryData.value = res.data.data.map(item => (  

        {
            ...item, 
            last_update: dateFormatter(item.last_update),
            updated_by : 'Mr example data',

        } 
    )).filter((item) => item.total !== 0)
    console.log(res.data)
    }).catch(err => {
    console.error(err)
    })
};

onMounted(() => {
    getAll();
});
</script>



<template>
    <HeaderContent title="Spoil"/>
    <div class="d-lg-flex justify-content-lg-between align-items-lg-center bg-white p-4 rounded-lg">
        <div class="d-lg-flex align-items-center">
            <div class="text-left mr-lg-2 mb-2 mb-lg-0">
            <label for="" class="">Start Date</label>
            <BFormInput type="date" class="mr-2" v-model="startDate"></BFormInput>
            </div>
            <div class="text-left mb-2 mb-lg-0">
            <label for="" class="">End Date</label>
            <BFormInput type="date" class="mr-2" v-model="endDate"></BFormInput>
            </div>
        </div>
        <div class="d-lg-flex">
            <FilterSearch :filter="false"/>
            <!-- <ButtonCta v-if="inventoryName == 'warehouse'" text="Add Inventory" show="true" @action="inventoryModal = !inventoryModal"></ButtonCta> -->
        </div>
    </div>
    <!-- Statistic -->
    
    <div class="mt-4 table-responsive bg-white rounded-3 mb-0">
        <!-- <div class="px-4 pt-4 d-lg-flex align-items-center justify-content-start">
            <ButtonCta class="" v-if=" inventoryName !== 'spoil' && inventoryName !== 'overall' " text="Add New" show="true" @action="inventoryModal = !inventoryModal"></ButtonCta>
        </div> -->
        <DataTable :data="inventoryData" :header="fields" :currentPage="currentPage" :custom-actions="customActions"></DataTable>
    </div>

    <!-- Modal Detail -->
    <BModal id="modal-tall" v-model="detailModal.showModal" :title="detailModal.detailName"> 
        <BTable :items="detailModal.dataDetail">

            
        </BTable>

        <h5>Total item : {{ detailModal.detailTotal }}</h5>
        <template #footer>
          <div class="d-flex justify-content-end">
              <BButton variant="primary" @click="detailModal.showModal = false" class="mr-2">Save</BButton>
              <BButton variant="danger" @click="detailModal.showModal = false">Cancel</BButton>
          </div>
      </template>
    </BModal>
</template>

<script>


// const spoilData = [
//     {
//         id: 'I001',
//         name: 'Double Sheet',
//         category: 'Item',
//         total: 3,
//         last_updated : '01/02/2025',
//         updated_by : 'Mr Admin',
//         detail : [
//             {
//                 qty : 1,
//                 updated_at : '01/02/2025',
//                 remark : 'Rusak karena puntung rokok'
//             },
//             {
//                 qty : 2,
//                 updated_at : '01/02/2025',
//                 remark : 'Kotor karena makanan'
//             }

//         ]
//     },
//     {
//         id: 'I002',
//         name: 'Single Sheet',
//         category: 'Item',
//         total: 4,
//         last_updated : '01/02/2025',
//         updated_by : 'Mr Admin',
//         detail : [
//             {
//                 qty : 2,
//                 updated_at : '01/02/2025',
//                 remark : 'Rusak karena puntung rokok'
//             },
//             {
//                 qty : 2,
//                 updated_at : '01/02/2025',
//                 remark : 'Kotor karena makanan'
//             }

//         ]
//     },
//     {
//         id: 'I003',
//         name: 'Bath Towel',
//         category: 'Item',
//         total: 2,
//         last_updated : '01/02/2025',
//         updated_by : 'Mr admin',
//         detail : [
//             {
//                 qty : 1,
//                 updated_at : '01/02/2025',
//                 remark : 'Rusak karena puntung rokok'
//             },
//             {
//                 qty : 1,
//                 updated_at : '01/02/2025',
//                 remark : 'Kotor karena makanan'
//             }

//         ]
//     },
    
// ]

</script>